import { ReactNode, useEffect, useState } from 'react';

import { CarouselApi } from '@componentLibrary/Carousel/carousel';
import ImageCarousel from '@componentLibrary/ImageCarousel';
import Typography from '@componentLibrary/Typography';
import { useMediaQuery } from '@mui/material';
import Autoplay from 'embla-carousel-autoplay';

import FullscreenSplitModal from '@components/fullscreen-split-modal/fullscreen-split-modal';

const LoginPromo = ({
    loginForm,
    isEmployee = false,
}: {
    loginForm: ReactNode;
    isEmployee?: boolean;
}) => {
    const [carouselApi, setCarouselApi] = useState<CarouselApi>();
    const [current, setCurrent] = useState(1);
    const hidePromo = useMediaQuery(`(max-width:1280px)`);

    useEffect(() => {
        if (!carouselApi) {
            return;
        }

        setCurrent(carouselApi.selectedScrollSnap() + 1);

        carouselApi.on('select', () => {
            setCurrent(carouselApi.selectedScrollSnap() + 1);
        });
    }, [carouselApi]);

    const content = isEmployee
        ? [
              {
                  text: 'Get paid to build your skills on the floor.',
                  image: '/static/images/login-promo/Graphic_EMP01.png',
              },
              {
                  text: 'Explore product tips and quick lessons while on shift.',
                  image: '/static/images/login-promo/Graphic_EMP02.png',
              },
              {
                  text: 'See what Events are happening in your store today.',
                  image: '/static/images/login-promo/Graphic_EMP03.png',
              },
          ]
        : [
              {
                  text: 'Empower employees to succeed with Courses.',
                  image: '/static/images/login-promo/Graphic_ADM01.png',
              },
              {
                  text: 'View all of your events on a single calendar.',
                  image: '/static/images/login-promo/Graphic_ADM03.png',
              },
              {
                  text: 'Analyze Spark effectiveness with new metrics.',
                  image: '/static/images/login-promo/Graphic_ADM02.png',
              },
          ];

    return (
        <>
            {hidePromo ? (
                <div className="flex w-full justify-center">{loginForm}</div>
            ) : (
                <FullscreenSplitModal
                    isVisible
                    left={loginForm}
                    right={
                        <div className="flex flex-col gap-3 p-4 h-full justify-center bg-cerulean-600 text-center">
                            <div className="flex justify-center w-full">
                                <Typography
                                    variant="sm"
                                    className="text-gray-950 font-semibold py-1 px-2 bg-white rounded w-fit"
                                >
                                    Latest updates
                                </Typography>
                            </div>
                            <Typography variant="xl" className="font-bold text-white">
                                {content[current - 1].text}
                            </Typography>
                            <ImageCarousel
                                items={content.map((item, index) => (
                                    <img
                                        src={item.image}
                                        alt=""
                                        style={{ width: '100%' }}
                                        key={index}
                                    />
                                ))}
                                setCarouselApi={setCarouselApi}
                                showButtons={false}
                                className="h-fit"
                                carouselClassName="w-full h-fit"
                                navigationDotsClassName="-bottom-4"
                                plugins={[Autoplay({ delay: 5000 }) as any]}
                                opts={{
                                    loop: true,
                                }}
                            />
                        </div>
                    }
                    onClose={() => {}}
                    showHeader={false}
                    showCloseButton={false}
                    className="flex !z-[8]"
                />
            )}
        </>
    );
};

export default LoginPromo;
